import { get, put, post, deleteRequest } from 'utils/api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { putFileUrlsInHtml } from 'common/utils/post-images';

import TYPES from './types';

export const getBeaconPost = createAsyncThunk(
  TYPES.GET_BEACON_POST,
  async (params, { rejectWithValue }) => {
    try {
      const res = await get(`/beacon/posts/${params.id}`);
      const post = { ...res.data };

      return { ...post, content: putFileUrlsInHtml(post.content, post.attachments) };
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const createBeaconPost = createAsyncThunk(
  TYPES.CREATE_BEACON_POST,
  async (params, { rejectWithValue }) => {
    try {
      const res = await post('/beacon/posts', params);

      return res?.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const editBeaconPost = createAsyncThunk(
  TYPES.EDIT_BEACON_POST,
  async (params, { rejectWithValue }) => {
    try {
      const res = await put(`/beacon/posts/${params.id}`, params);

      return res?.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const deleteBeaconPost = createAsyncThunk(
  TYPES.DELETE_BEACON_POST,
  async (params, { rejectWithValue }) => {
    try {
      const res = await deleteRequest(`/beacon/posts/${params.id}`, params);

      return res?.data;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);
